/** Por que a sessão caiu — dito só quando se sabe (M-B B1, 28/09). Lido em pages/Login.js:22. */
export const MOTIVO_SAIDA = {
  outroLugar: 'Sua sessão foi encerrada porque este login foi usado em outro lugar — o sistema permite '
    + 'uma sessão por vez. Entre de novo; o que você tinha digitado não foi salvo.',
  venceu: 'Sua sessão expirou por falta de uso. Entre de novo; o que você tinha digitado não foi salvo.',
  desconhecido: 'O servidor encerrou sua sessão. Entre de novo; o que você tinha digitado não foi salvo.',
};

export function expDoToken(token) {
  try {
    const corpo = String(token).split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const p = JSON.parse(atob(corpo));
    return typeof p.exp === 'number' ? p.exp : null;
  } catch {
    return null;
  }
}

export function motivoDaSaida(error, token, agoraMs = Date.now()) {
  const d = error?.response?.data;
  if (d?.motivo === 'sessao_substituida') return MOTIVO_SAIDA.outroLugar;          // backend/src/auth/jwt.strategy.ts
  const exp = expDoToken(token);
  if (exp != null && exp * 1000 <= agoraMs) return MOTIVO_SAIDA.venceu;           // auth.module.ts:30 (1 h)
  // Janela até o back com `motivo` ir ao ar: o único 401 com este texto no caminho do passport é o do
  // token_version (backend/src/auth/jwt.strategy.ts:44-47).
  if (d?.message === 'Token inválido') return MOTIVO_SAIDA.outroLugar;
  return MOTIVO_SAIDA.desconhecido;
}
